import { render, staticRenderFns } from "./worganization.vue?vue&type=template&id=6cffdb40"
import script from "./worganization.vue?vue&type=script&lang=js"
export * from "./worganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports